const s = (t) => {
  const [e, r] = t.split(" ");
  return { firstName: e, lastName: r };
};
export {
  s as getCardHolderFirstLastName
};
